<template>
  <div class="input">
    <div class="input-block"
      v-for="(item, index) in profitInputData"
      :style="{flex : item.flex}"
      :key="index">
      <div class="input-block__title input-block--bold">
        {{ item.title }}
        <span class="input-block__tip input-block--bold input-block--blue"
          v-if="index === 'operatingExpenses'">
          (仅针对该商品)
        </span>
        <span class="input-block__btn"
          v-if="index === 'packData'"
          @click="inputChangeInformUp($event, 'unitIndex', (Number(budgetProfitData.unitIndex) + 1) % 2)">
          英制公制转换
        </span>
      </div>
      <div v-for="(input, i) in item.input" :key="input.data">
        <div class="input-block__line" v-if="input.show">
          <div class="input-block__name" :class="'input-block__name' + item.width">
            <span
              :class="{'input-block__name--selected': input.html && input.showDetail}">
              {{ input.name }}
            </span>
            <span class="input-block__tip input-block--bold input-block--blue">
              <template v-if="input.data === 'stockPrice' && (budgetProfitData.xxts || budgetProfitData.xxts == 0)">
                (<template v-if="budgetProfitData.xxts == 1">不</template>含税)
              </template>
              <template v-if="input.icon == 'national' && (budgetProfitData.countrySite || budgetProfitData.countrySite == 0)">
                ({{ countryCurrencyArray[budgetProfitData.countrySite] }})
              </template>
            </span>
            <div v-if="input.html || input.data === 'importTariff'"
              @mouseover="showDetailHtml(index, i)"
              @mouseleave="cancelDetailHtml(index, i)">
              <div
                :class="{
                  'input-block__detail1': input.data === 'importTariff',
                  'input-block__detailR': index === 'productRevenue',
                  'input-block__detail': index !== 'productRevenue'
                }"
                v-if="input.showDetail"
                v-html="input.html"></div>
              <img src="../img/问号.png" alt=""
                class="input-block__img">
            </div>
          </div>
          <div class="input-block__input"
            :class="{
              'input-block__input--disable': isDisable || input.isDisable,
              'input-block__input--prompt' :
                (isPrompt && !budgetProfitData[input.data] && budgetProfitData[input.data] != 0) ||
                (isPromptByLogistics && logisticsNeedData.includes(input.data) && !budgetProfitData[input.data] && budgetProfitData[input.data] != 0),
              'input-block__input--lengthen': index === 'operatingExpenses' || index === 'productRevenue'
            }">
            <div class="input-block__icon"
              :class="{'input-block--blue': input.icon === getInputEnumType('NATIONAL')}"
              v-if="getInputEnumDom(input.icon)">
              {{ getInputEnumDom(input.icon) }}
            </div>
            <template v-if="input.type === 'select'">
              <select
                :name=input.name
                :id=input.data
                :value="budgetProfitData[input.data]"
                :disabled="isDisable || input.isDisable"
                :class="{'input-block__input--placeholder': budgetProfitData[input.data] == null}"
                @change="inputChangeInformUp($event, input.data)">
                <option value="" hidden>{{ input.pla }}</option>
                <option
                  class="input-block__option"
                  v-for="(a, i) in input.array"
                  :key="a"
                  :value="i">
                  {{ a }}
                </option>
              </select>
            </template>
            <template v-else>
              <input
                :type=input.type
                :value="budgetProfitData[input.data]"
                :disabled="isDisable || input.isDisable"
                @blur="inputBlur(input.decimal, input.data)"
                @input="inputChangeInformUp($event, input.data)">
              <span class="input-block__percent" v-if="isNeedPercentData.includes(input.data)">%</span>
            </template>
          </div>
          <div class="input-block__unit" v-if="index === 'stockCost' || index === 'productRevenue' || index === 'packData'">
            <template v-if="getInputEnumDom(input.unit)">({{ getInputEnumDom(input.unit) }})</template>
          </div>
          <template v-if="input.data === 'importTariff'">
            <div class="input-block__dowm" @click="openTaxDialog"></div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { BudgetProfitTest, ProfitInputNewModule, INPUTENUM } from "common/dataClass/Profit";
  import globalData from "common/globalData";
  export default {
    name: "inputModule",
    data(){
      return{
        /**预算输入模块数据 */
        profitInputData: ProfitInputNewModule.NEWINPUT(),
        /**货币数组 */
        countryCurrencyArray: globalData.countryCurrencyInvariant,
        /**需要显示百分号的数据 */
        isNeedPercentData: [
          'operatingAnnualInterestRate', 'sqrkgsl', 'salesCommission',
          'operationCommission', 'commission', 'recoveryLossRate'
        ],
        /**定时器 */
        detailTimer: null,
        /**物流弹窗所需数据对应Key */
        logisticsNeedData: Object.keys(BudgetProfitTest.LOGISTICSVERITYDATA()),
        /**店铺数据 */
        storeData: []
      }
    },
    props: {
      /**预算计算基础数据 */
      budgetProfitData: {
        type: BudgetProfitTest
      },
      /**是否能修改 */
      isDisable:{
        type: Boolean,
        default: false
      },
      /**是否提示未输入数据的输入框 */
      isPrompt: {
        type: Boolean,
        default: false
      },
      /**是否显示结果 */
      isShowResult: {
        type: Boolean,
        default: false
      },
      /**是否提示未输入数据的输入框(物流弹窗) */
      isPromptByLogistics: {
        type: Boolean,
        default: false
      },
      /**输入框类型 */
      inputType: {
        type: String,
        default: 'normal'
      }
    },
    methods: {
      /**输入框数据改变 通知父组件 */
      inputChangeInformUp(event, key, v = null){
        let value
        if(v === null){
          value = event.target.value
        }else {
          value = v
        }
        this.$emit('budgetChange', {
          key: key,
          value: value
        })
      },
      /**返回枚举对应string */
      getInputEnumType(str){
        return INPUTENUM[str]
      },
      /**返回枚举对应dom */
      getInputEnumDom(unit){
        let array = INPUTENUM.judgeEnumReturnString[unit]
        let index = unit === INPUTENUM.NATIONAL || unit === INPUTENUM.DEFAULT ? this.budgetProfitData.countrySite :
          unit === INPUTENUM.LENGTH || unit === INPUTENUM.WEIGHT ? this.budgetProfitData._unitIndex :
          unit === INPUTENUM.UNIT || unit === INPUTENUM.PERUNIT ? this.budgetProfitData.unit : null
        return !index && index !== 0 ? '' : array[index]
      },
      /**鼠标停留在对应的输入框名称上 */
      showDetailHtml(index, i){
        const _this = this
        clearTimeout(this.detailTimer)
        this.detailTimer = setTimeout(() => {
          _this.profitInputData[index].input[i].showDetail = true
        }, 500);
      },
      /**鼠标离开对应的输入框名称上 */
      cancelDetailHtml(index, i){
        clearTimeout(this.detailTimer)
        this.detailTimer = null
        this.profitInputData[index].input[i].showDetail = false
      },
      /**保留小数点数位 */
      keepDecimalPoint: globalData.keepDecimalPoint,
      /**用户取消聚焦输入框 */
      inputBlur(decimal, key){
        let num
        if(!this.budgetProfitData[key]){
          num = 0
        }else{
          num = this.keepDecimalPoint(this.budgetProfitData[key], decimal)
        }
        this.inputChangeInformUp(null, key, num)
      },
      /**让父级打开税务弹窗 */
      openTaxDialog(){
        this.$emit('openTaxDialog', { bool: true, type: 'input' })
      }
    },
    computed:{
      storeList(){
        return JSON.stringify(this.$store.state.storeList)
      }
    },
    watch: {
      'budgetProfitData.countrySite':{
        handler(newVal){
          // 只有美国站有合仓设置，其他默认未合仓
          if(newVal != 0 && newVal != null){
            this.budgetProfitData.warehouseConfiguration = '1'
            this.profitInputData.sellerInfo.input.warehouseConfiguration.isDisable = true
          }else{
            this.profitInputData.sellerInfo.input.warehouseConfiguration.isDisable = false
          }
          this.profitInputData.stockCost.input.importTariff.html = globalData['importTariffInputHtml' + newVal]
        },
        immediate: true
      },
      // 'budgetProfitData.sqbs':{
      //   handler(newVal){
      //     if(newVal != 0){
      //       this.profitInputData.stockCost.input.saleTax.show = true
      //       this.profitInputData.stockCost.input.sqrkgsl.show = true
      //     }else{
      //       this.profitInputData.stockCost.input.saleTax.show = false
      //       this.profitInputData.stockCost.input.sqrkgsl.show = false
      //     }
      //   },
      //   immediate: true
      // },
      storeList: {
        immediate: true,
        handler(newVal){
          this.storeData.splice(0, this.storeData.length)
          let arr = JSON.parse(newVal)
          arr.map(obj => this.storeData.push(obj))
        }
      },
      inputType: {
        immediate: true,
        handler(newVal){
          let obj = {
            'normal': () => {
              this.profitInputData = ProfitInputNewModule.NEWINPUT()
            },
            'store' : async () => {
              this.profitInputData = ProfitInputNewModule.NEWINPUTBYSTORE()
              if(this.profitInputData.sellerInfo.input.store.array == undefined){
                this.profitInputData.sellerInfo.input.store.array = []
              }
              this.profitInputData.sellerInfo.input.store.array.splice(0, this.profitInputData.sellerInfo.input.store.array.length)
              this.storeData.map(obj => {
                this.profitInputData.sellerInfo.input.store.array.push(obj.storeName)
              })
            }
          }
          obj[newVal]()
        }
      }
    },
    created() {
      this.profitInputData.stockCost.input.importTariff.show = this.isShowResult
      this.profitInputData.stockCost.input.importTariff.isDisable = true
      this.profitInputData.stockCost.input.sqbs.isDisable = true
      this.profitInputData.stockCost.input.importTariff.html = globalData['importTariffInputHtml' + this.budgetProfitData.countrySite]
    }
  }
</script>

<style scoped lang="scss">
.input{
  width: 1500px;
  display: flex;
  justify-content: space-between;
  border-radius: 5px;
  background-color: rgba($color: #000000, $alpha: 0);
  &-block{
    color: black;
    font-size: 14px;
    padding: 5px;
    position: relative;
    &__title{
      font-size: 18px;
      margin: 10px 0;
      white-space: nowrap;
    }
    &__tip{
      font-size: 12px;
    }
    &__btn{
      font-size: 12px;
      color: #fff;
      background-color: #1c99fd;
      font-weight: lighter;
      border-radius: 5px;
      padding: 6px 4px;
      white-space: nowrap;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
    &__line{
      margin: 5px 0;
      display: flex;
      position: relative;
    }
    &__name{
      line-height: 24px;
      position: relative;
      display: flex;
      &--selected{
        color: #FCA605;
      }
    }
    &__detail{
      position: absolute;
      background-color: #dbedfc;
      top: 15px;
      left: 0px;
      color: black;
      font-size: 12px;
      z-index: 15;
      line-height: 15px;
      border: 1px solid #a8a8a8;
      border-radius: 8px;
      padding: 5px;
      width: 450px;
      font-size: 12px;
      &::after{
        content: '';
        position: absolute;
        left: 8px;
        top: -6px;
        width: 10px;
        height: 10px;
        margin-bottom: -10px;
        background: inherit;
        /*自动继承父元素的背景*/
        transform: rotate(45deg);
        border-left: 1px solid #a8a8a8;
        border-top: 1px solid #a8a8a8;
      }
    }
    &__detailR{
      position: absolute;
      background-color: #dbedfc;
      top: 15px;
      right: 0px;
      color: black;
      font-size: 12px;
      z-index: 15;
      line-height: 15px;
      border: 1px solid #a8a8a8;
      border-radius: 8px;
      padding: 5px;
      width: 450px;
      font-size: 12px;
      &::after{
        content: '';
        position: absolute;
        right: 100px;
        top: -6px;
        width: 10px;
        height: 10px;
        margin-bottom: -10px;
        background: inherit;
        /*自动继承父元素的背景*/
        transform: rotate(45deg);
        border-left: 1px solid #a8a8a8;
        border-top: 1px solid #a8a8a8;
      }
    }
    &__detail1{
      width: 900px;
    }
    &__name1{
      width: 165px;
    }
    &__name2{
      width: 80px;
    }
    &__name3{
      width: 145px;
    }
    &__name4{
      width: 170px;
    }
    &__img{
      width: 12px;
      position: absolute;
      top: 50%;
      transform: translateY(-70%);
    }
    &__input{
      width: 100px;
      display: flex;
      justify-content: center;
      border: 1px solid #7f9db9;
      border-radius: 5px;
      overflow: hidden;
      overflow-x: visible;
      text-align: center;
      position: relative;
      input{
        border: none;
        outline: none;
        width: 80px;
        text-align: center;
        height: 24px;
        overflow: hidden;
        color: #7b7b7b;
        background: rgba($color: #000000, $alpha: 0);
      }
      select{
        border: none;
        outline: none;
        width: 85px;
        text-align: center;
        height: 24px;
        color: #7b7b7b;
        background: rgba($color: #000000, $alpha: 0);
      }
      select > option[hidden]{
        display: none;
      }
      input[disabled],input:disabled,input.disabled{
        color: #e8e8e8;
        -webkit-text-fill-color: #c7b7b7;
        opacity: 1;
      }
      select[disabled],select:disabled,select.disabled{
        color: #e8e8e8;
        -webkit-text-fill-color: #c7b7b7;
        opacity: 1;
        -moz-appearance: none; /* Firefox */
        -webkit-appearance: none; /* Safari 和 Chrome */
        appearance: none;
      }
      &--disable{
        background: #f5f5f5;
      }
      &--prompt{
        border-color: red;
      }
      &--placeholder{
        &::selection{
          color: #c7c7c7 !important;
        }
      }
      &--lengthen{
        width: 125px;
      }
    }
    &__option{
      color: black;
    }
    &__percent{
      position: absolute;
      top: 50%;
      right: 1px;
      transform: translateY(-50%);
      color: #7b7b7b;
    }
    &__unit{
      font-size: 14px;
      color: #7b7b7b;
      font-weight: lighter;
      line-height: 24px;
      padding: 0 2px;
      width: 40px;
    }
    &__icon{
      position: absolute;
      left: 1px;
      font-size: 12px;
      color: #7b7b7b;
      line-height: 24px;
      text-align: left;
      z-index: 5;
    }
    &__dowm{
      position: absolute;
      right: 35px;
      top: 50%;
      transform: translateY(-50%);
      width: 0;
      height: 0;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 8px solid black;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
    &--blue{
      color: #19acfd;
    }
    &--bold{
      font-weight: bold;
    }
  }
}
</style>
